import { useFormikContext } from 'formik';
import { InputTextField } from '.';
import { fieldsTo } from '@lib/constants/fields';

import { validationFunction } from '@modules/business/validation/validateKeyEntry';
import { useMemo } from 'react';

export const ToFields = () => {
  const form = useFormikContext();
  const field = form.getFieldProps('deliveryMethod');
  const fields = useMemo(() => {
      switch (field.value.toString().toLowerCase()) {
          case 'email':
              return fieldsTo.email;
          case 'text':
              return fieldsTo.text;
          case 'print':
              return fieldsTo.printAdHome;
          default:
            return []
      }
  }, [field]);
  return (
    <div>
      {fields.map((item, _index) => (
            <div key={item.name} className="mb-5 w-full">
              <InputTextField
                label={item.label}
                name={item.name}
                maxlength={item.maxLength}
                type={item.type}
                onkeydown={validationFunction(item.type)}
                autocomplete={item.autocomplete}
              />
            </div>
          ))}
    </div>
  );
};

export default ToFields;
